// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ec7df750","769":"afd947c9"}[chunkId] + ".chunk.js";
};